import { Button, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import DialogButtons from "@entrilia/shared/components/DialogButtons";
import SmallDialog from "@entrilia/shared/components/SmallDialog";
import type { PendingProductAction } from "./clientProfilesTypes";

interface Props {
  pendingProductAction: PendingProductAction | undefined;
  isUpdatingProductState: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const ClientProfileProductConfirmDialog = ({
  pendingProductAction,
  isUpdatingProductState,
  onCancel,
  onConfirm,
}: Props) => {
  return (
    <SmallDialog open={Boolean(pendingProductAction)} onClose={isUpdatingProductState ? undefined : onCancel}>
      <DialogTitle>Confirm product update</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {pendingProductAction
            ? pendingProductAction.enabled
              ? `Enable ${pendingProductAction.name}?`
              : `Disable ${pendingProductAction.name}?`
            : ""}
        </DialogContentText>
      </DialogContent>
      <DialogButtons onCancel={onCancel} cancelDisabled={isUpdatingProductState}>
        <Button onClick={onConfirm} variant="contained" disabled={isUpdatingProductState}>
          Confirm
        </Button>
      </DialogButtons>
    </SmallDialog>
  );
};

export default ClientProfileProductConfirmDialog;
